module.exports.default = {
    "ORDER": "Commande",
    "SCHEDULE.YOU_ARE_ALL_SET": "Votre choix est enregistré",
    "SCHEDULE.YOUR_DELIVERY_IS_SCHEDULED_FOR": "Votre livraison a été planifiée",
    "SCHEDULE.CUSTOMER_#_MESSAGE": "Bonjour #, merci de plannifer votre livraison",
    "SCHEDULE.SCHEDULE_NOW": "Replanifier",
    "SCHEDULE.DELIVERY_STATUS_UPDATES": "Mises à jour des commandes et des status",
    "SCHEDULE.EMAIL_UPDATES": "Email",
    "SCHEDULE.SMS_UPDATES": "SMS",
    "SCHEDULE.DISABLE_UPDATES": "Je ne souhaite plus recevoir de notifications",
    "SCHEDULE.STATUS_UPDATE_IN_THE_FOLLOWING": "Je souhaite recevoir des notifications pour cette livraison via:",
    "OOPS": "Oups !",
    "SOMETHING_WENT_WRONG": "Erreur avec votre commande",
    "REFRESH": "Rafraichir",
    "PAGE_NOT_FOUND": "Page non trouvée",
    "COULD_NOT_FIND_PAGE": "Nous ne trouvons pas la page recherchée",
    "TRACKING.MESSAGE_DRIVER_FAILED": "Impossible d'envoyer un message vide",
    "TRACKING.MESSAGE_DRIVER_PLACEHOLDER": "Envoyez votre message au livreur",
    "TRACKING.SEND": "Envoyer via messagerie",
    "TRACKING.ARRIVING_AT": "Estimée à",
    "TRACKING.ETA": "ETA",
    "TRACKING.MIN": "min",
    "TRACKING.MAP": "Circulation",
    "TRACKING.SATELLITE": "Satellite",
    "TRACKING.TERRAIN": "Terrain",
    "TRACKING.DRIVER_ARRIVED_MESSAGE": "Bonjour, Je suis arrivé !",
    "TRACKING.DRIVER_ARRIVED_AT_MESSAGE": "est arrivé au",
    "COMPLETED": "Votre livraison est terminée",
    "RATING.SKIP": "Pas maintenant",
    "RATING.WHAT_WENT_WELL": "Point positif",
    "RATING.WHAT_WENT_WRONG": "Point négatif",
    "RATING.THANK_YOU": "Merci",
    "RATING.FOR_USING_OUR_SERVICE": "Merci d'avoir utilisé notre service !",
    "RATING.HOW_WAS_YOUR_DELIVERY": "Comment s'est déroulée votre livraison ?",
    "RATING.WHAT_WAS_YOUR_EXPERIENCE": "Aidez nous à améliorer notre service en nous notant",
    "SCHEDULE.RATE_US": "Notez nous !",
    "TERM_OF_USE": "Modalités d'utilisation",
    "PRIVACY_POLICY": "Confidentialité",
    "SHARING_MY_LOCATION": "Trouvez moi",
    "SHARING_LOADING": "Chargement",
    "REQUIRED_FIELD_MESSAGE": "Tous les champs sont requis",
    "CONTACT_NAME": "Nom de l'interlocuteur",
    "PHONE_NUMBER": "Numéro de téléphone",
    "EMAIL_ADDRESS": "Adresse email",
    "SEND": "Envoyé",
    "FORWARD.THIS_ORDER": "Transférer cette livraison",
    "FORWARD.TO_CONTACT": "Transférer au contact dans",
    "FORWARD.ARE_YOU_SURE_MESSAGE": "Êtes-vous sûr de vouloir transférer cette commande?",
    "FORWARDED.HAS_DELIVERY_FORWARDED_DELIVERY": "vous a fait parvenir une livraison",
    "FORWARDED.ARE_YOU_SURE_MESSAGE": "Êtes-vous sûr de vouloir refuser cette livraison?",
    "ACCEPT": "Accepter",
    "REJECT": "Rejeter",
    "PICKUP.SET_PICKUP_TIME": "Je suis en chemin",
    "PICKUP.IVE_ARRIVED": "Je suis arrivé(e)",
    "PICKUP.PICKUP_ETA_SET_FAILED": "Oups, une erreur est survenue",
    "PICKUP.ETA_SET_FAILED_DESCRIPTION": "Merci d'essayer de nouveau",
    "PICKUP.MIN": "min",
    "PICKUP.SHOW_THIS_NUMBER": "Présenter ce numéro au réceptionniste pour recevoir votre commande",
    "PICKUP.IM_OUTSIDE": "Je suis là",
    "PICKUP.LET_THEM_KNOW_YOUR_OUTSIDE?": "Prévenez-nous en arrivant.",
    "PICKUP.I_WILL_ARRIVE_AT": "J'arriverai à",
    "PICKUP.PICKUP_ETA_SUCCESSFULLY_SET": "L'heure de ramassage a été configurée avec succès",
    "PICKUP.IN": "Dans",
    "PICKUP.TO": "À",
    "PICKUP.COLLECT": "Commande collectée",
    "PICKUP.SELECT_METHOD_OF_TRANSPORT": "Sélectionner la méthode de transport",
    "PICKUP.CONFIRM_METHOD_OF_TRANSPORT": "Confirmer la méthode de transport",
    "PICKUP.CANCEL": "Annuler",
    "PICKUP.CONFIRM_TIME": "Confirmer l'heure de retrait",
    "TRACKING.DRIVER_ROUTE_ONE_STOP_MESSAGE": "Le livreur est à 1 arrêt de vous",
    "TRACKING.DRIVER_ROUTE_STOPS_MESSAGE_PART2": "arrêts de vous",
    "TRACKING.DRIVER_ROUTE_STOPS_MESSAGE_PART1": "Le livreur est à",
    "PICKUP.OK": "Ok",
    "PICKUP.NEXT": "Suivant",
    "PICKUP.SKIP": "Passer",
    "CAR_ARRIVED.TITLE": "Heureux que vous soyez arrivé. Aidez-nous à vous localiser:",
    "CAR_ARRIVED.PARKING_SPOT": "Aire et numéro de place de parking",
    "CAR_ARRIVED.LICENSE_PLATE": "Plaque d'immatriculation",
    "CAR_ARRIVED.VEHICLE_MODEL": "Modéle et marque du véhicule",
    "CAR_ARRIVED.VEHICLE_COLOR": "Couleur du véhicule",
    "CAR_ARRIVED.REMEMBER": "Se souvenir des détails du véhicule",
    "CAR_ARRIVED.PARKING_SPOT_EXAMPLE": "(Exemple: C - 49)",
    "CAR_ARRIVED.LICENSE_PLATE_EXAMPLE": "(Exemple:AA-123-ZZ)",
    "CAR_ARRIVED.VEHICLE_MODEL_EXAMPLE": "(Exemple: Renault Clio)",
    "CAR_ARRIVED.VEHICLE_COLOR_EXAMPLE": "(Exemple: Bleu)",
    "REDIRECT_PICKUP.TO": "À",
    "REDIRECT_PICKUP.CONFIRM_TITLE": "Modifier le lieu du retrait",
    "REDIRECT_PICKUP.SUCCESS_TITLE": "Le lieu de retrait a été modifié avec succès",
    "REDIRECT_PICKUP.FAILED_TITLE": "Le lieu de retrait n'a pu être changé",
    "REDIRECT_PICKUP.FAILED_DESCRIPTION": "Une erreur est survenue",
    "REDIRECT_PICKUP.OK": "Ok",
    "REDIRECT_PICKUP.KM": "Km",
    "REDIRECT_PICKUP.SELECT_PICKUP_LOCATION": "Choisir un lieu de retrait",
    "REDIRECT_PICKUP.SET_AS_PICKUP_LOCATION": "Définir comme lieu de retrait",
    "REDIRECT_PICKUP.PICKUP_OPTIONS": "Options de retrait",
    "SOON": "Bientôt",
    "TRACKING.WANT_TO_CALL_YOUR_DRIVER": "Souhaitez-vous contacter votre livreur?",
    "GLOBAL.CALL": "Appeler",
    "GLOBAL.CANCEL": "Annuler",
    "﻿PICKUP.SET_PICKUP_TIME": "Je suis en route",
    "RATING.PROOF_OF_DELIVERY_MESSAGE": "Votre commande vous attend devant votre porte!",
    "SCHEDULED.THANKS_FOR_USING": "Merci d'avoir choisir {{merchant_name}}",
    "SCHEDULED.SHIPMENT_IN_TRANSIT": "Votre envoi {{external_id}} est en court de transfert",
    "SCHEDULED.YOUR_DELIVERY_IS_SCHEDULED_FOR": "Votre livraison est prévue pour",
    "Submit": "Valider",
    "RATING.SELECT_STARS_BEFORE_SUBMIT": "Pour évaluer, veuillez cocher tout d’abord les étoiles",
    "PICKUP.SHOW_ID": "Afficher l'ID",
    "TRACKING.ESTIMATED_TIME_ARRIVAL": "Heure d'arrivée estimée",
    "OPEN_MENU": "Ouvrir le menu",
    "CLOSE_MENU": "Fermer le menu",
    "MAP_AUTO_CENTER": "Centrer automatiquement la carte",
    "MAP_SETTINGS": "Paramètres de la carte",
    "ZOOM_OUT": "Zoom arrière",
    "ZOOM_IN": "Zoom avant",
    "TRACKING.CALL_DRIVER": "Chauffeur d'appel",
    "TRACKING.MESSAGE_DRIVER": "Envoi du conducteur",
    "PICKUP.SELECT_TIME_TO_CONFIRM": "Confirmer l'heure d'arrivée pour la prise en charge",
    "PICKUP.SET_OR_ARRIVE_DESCRIPTION": "Nous ne voulons pas vous faire attendre.\nFaites-nous savoir quand vous êtes en route ou quand vous arrivez :",
    "SCHEDULE.TIME_ZONE_TEXT": "Fuseau horaire",
    "TRACKING.THANKS_MESSAGE_SUBTITLE": "Nous finalisons votre commande !",
    "TRACKING.THANKS_MESSAGE_TEXT": "Un employé s'apprête à vous apporter votre commande à votre véhicule.\n\nAfin de nous assurer que vous ayez le meilleur service, veuillez informer le magasin de votre arrivée en appelant le numéro de téléphone indiqué à votre emplacement de stationnement.",
    "TRACKING.THANKS_MESSAGE_TITLE": "Merci de nous avoir avisé de votre arrivée",
    "TRACKING.CLICK_COLLECT_MESSAGE_TEXT": "Veuillez vous rendre au point de collecte en magasin où votre commande est prête à être récupérée",
    "CANCEL_ORDER": "Annuler la commande",
    "CANCELLATION_VALIDATION_TITLE": "Êtes-vous sûr de vouloir annuler cette commande ?",
    "CANCELLATION_VALIDATION_BACK": "Retour",
    "CANCELLATION_VALIDATION_YES": "Oui, s'il vous plaît",
    "CANCEL_SUCCESS": "Nous avons annulé votre commande",
    "CANCEL_PAST_ALLOWED": "Annulation de la commande expirée",
    "CANCEL_ERROR": "Nous n'avons pas pu annuler votre commande",
    "RATING.FREE_TEXT_COMMENT": "Dites-nous en plus",
    "RATING.ORDER_DELIVERED_GREEN": "Nous avons livré votre commande avec un véhicule écologique",
    "CX_ORDER_STATUS.CONFIRMED": "Commande confirmée. Nous nous en occupons.",
    "CX_ORDER_STATUS.RECEIVED": "Commande reçue. Nous serons en contact sous peu.",
    "CX_ORDER_STATUS.FINDING_DRIVER": "Nous trouvons un livreur pour votre commande.",
    "CX_ORDER_STATUS.DRIVER_FOUND": "Nous avons identifié le livreur de votre commande.",
    "CX_ORDER_STATUS.PICKING_UP": "Nous collectons actuellement votre commande.",
    "CX_ORDER_STATUS.WAY_TO_PICKUP": "Nous sommes sur le point de collecter votre commande.",
    "CX_ORDER_STATUS.ON_PREVIOUS_DELIVERY": "Nous terminons une livraison avant votre commande.",
    "CX_ORDER_STATUS.WAY_TO_DROPOFF": "Votre commande est désormais en route.",
    "CX_ORDER_STATUS.ARRIVED": "Votre commande est arrivée!",
    "TRACKING.DELIVERY_STATUS_TITLE": "Statut de livraison",
    "CONFIGURATION.TAGS.SHOW_DELIVERY_STATUS": "Afficher le statut de livraison aux clients",
    "CONFIRM": "Confirmer",
    "FLOW_OPTIONS.TITLE": "Comment voulez-vous collecter votre commande?",
    "FLOW_OPTIONS.CURBSIDE_BUTTON_LABEL": "Livraison à votre voiture dans une place pré-définie",
    "FLOW_OPTIONS.CURBSIDE_BUTTON_TEXT": "Point de collecte",
    "FLOW_OPTIONS.CLICK_AND_COLLECT_LABEL": "Collecte en magasin ou à un endroit défini",
    "FLOW_OPTIONS.CLICK_AND_COLLECT_TEXT": "Click & collect",
    "RATING_STAR_ALT": "Sélectionnez jusqu'à 5 étoiles pour soumettre une évaluation",
    "RATING_STAR_ALT_ONE": "Sélectionnez pour laisser la note",
    "RATING_STAR_ALT_TWO": "stars",
    "TRACKING.ARRIVING_IN_ARIA_LABEL": "Le temps d'arrivée estimé est",
    "TRACKING.MAP_CONTAINER_ARIA_LABEL": "Carte pour suivre la commande",
    "SCHEDULE.EXTERNAL_ID_INFO": "Commande ID: {{externalId}}",
    "SCHEDULE.TASK_NOTE_LABEL": "Commentaire",
    "SCHEDULE.CANCEL_NOTE_INPUT": "Effacer",
    "DELIVERY_WAS_CANCELLED": "Livraison annulée",
    "QUESTIONNAIRE.SKIP": "Passer",
    "QUESTIONNAIRE.SKIP_VALIDATION_HEADER": "Êtes-vous sûr de vouloir ignorer ?",
    "QUESTIONNAIRE.SKIP_VALIDATION_MESSAGE": "Certaines questions n'ont pas reçu de réponse. Êtes-vous sûr de vouloir continuer sans les avoir complétées ?",
    "QUESTIONNAIRE.BACK": "Retour",
    "QUESTIONNAIRE.SUBMIT_FAILED": "",
    "QUESTIONNAIRE.SUBMIT_SUCCESS": "",
    "QUESTIONNAIRE.NA_VALUE": "",
    "QUESTIONNAIRE.SUBMIT_SUCCESS_TITLE": "",
    "QUESTIONNAIRE.SUBMIT_SUCCESS_MESSAGE": ""
};
	